import { FileIcon } from '@components/files/icon'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'

export type AttachedFile = {
  id?: string
  name: string
  preview_url?: string
  size: number
  type: string
  progress: number
}

export function AttachedFiles({
  files,
  setFiles,
}: {
  files: AttachedFile[]
  setFiles: (files: AttachedFile[]) => void
}) {
  const handleRemoveFile = (index: number) => {
    const newFiles = [...files]
    newFiles.splice(index, 1)
    setFiles(newFiles)
  }

  if (files.length === 0) return null
  return (
    <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
      {files.map((file, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '4px 8px',
            border: '1px solid #ccc',
            borderRadius: '16px',
            backgroundColor: '#fff',
            minWidth: '150px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FileIcon
              extension={file.name.split('.').pop() || ''}
              style={{ marginRight: '4px' }}
            />
            {file.preview_url ? (
              <Box
                component="a"
                href={file.preview_url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  marginRight: '8px',
                  flex: 1,
                  textDecoration: 'none',
                  color: 'inherit',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                {file.name}
              </Box>
            ) : (
              <Box
                component="span"
                sx={{ marginRight: '8px', flex: 1 }}
              >
                {file.name}
              </Box>
            )}
            <button
              onClick={() => handleRemoveFile(index)}
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                lineHeight: '16px',
              }}
            >
              &times;
            </button>
          </Box>
          {file.progress < 1 && (
            <LinearProgress
              variant="determinate"
              value={file.progress * 100}
              sx={{ marginTop: '4px', borderRadius: '4px' }}
            />
          )}
          {file.progress === 1 && !file.id && (
            <LinearProgress
              variant="indeterminate"
              value={100}
              sx={{ marginTop: '4px', borderRadius: '4px' }}
            />
          )}
        </Box>
      ))}
    </Box>
  )
}
